import React from 'react';
import Page from '../../components-core/Page';
import { useQuery } from 'react-fetching-library';
import { Box, Card, CardContent, CardHeader, Stack, CircularProgress } from '@mui/material';
import ClientDetails from '../../sections/client/client-page/ClientDetails';
import Events from '../../sections/client/client-page/Events';
import { SnackbarAlert } from '../../components-core/SnackbarAlert';
import { getClientDataAction } from '../../services/request';
import { useFullScreen } from '../../services/hooks';

const ClientData = () => {
  const [client, setClient] = React.useState(null);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const { loading, payload, error } = useQuery(getClientDataAction());

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  React.useEffect(() => {
    if (!error && !loading) {
      setClient(payload);
    }

    if (error) {
      setOpenSnackbar(true);
    }
  }, [loading]);

  return (
    <Page title="Twoje Dane" >
      {/* <Stack direction={useFullScreen() ? 'column' : 'row'} justifyContent="center" alignItems="center" spacing={4}> */}
      <Stack direction="column" justifyContent="center" alignItems="center" spacing={4}>
        <Card>
          <CardHeader title="Twoje dane" />
          <CardContent>
            {loading ? <Box width={500} height={300}><CircularProgress /></Box> : <ClientDetails {...client} />}
          </CardContent>
        </Card>
        <Stack direction="row" spacing={4}>
          <Card>
            <CardHeader title="Dokumenty " />
            <CardContent>
              <ul>
                <li><a target="_blank" rel="noreferrer" href="https://jujutsupoland.com/wp-content/uploads/2026/05/REGULAMIN-PLATNOSCI-na-strone-Kepno-OSTROW-WLKP.czerwiec-2026.pdf">REGULAMIN-PLATNOSCI-Kepno-OSTROW-WLKP.-2026.pdf</a></li>
                <li><a target="_blank" rel="noreferrer" href="https://jujutsupoland.com/wp-content/uploads/2020/09/Oswiadczenie-COVID-DOROSLI-2020.pdf">Oświadczenie o stanie zdrowia - dorośli</a></li>
                <li><a target="_blank" rel="noreferrer" href="https://jujutsupoland.com/wp-content/uploads/2020/09/Oswiadczenie-o-stanie-zdrowia-dziecka-MOHIKAN-2020-nowe.pdf">Oświadczenie o stanie zdrowia - dzieci</a></li>
                <li><a target="_blank" rel="noreferrer" href="https://jujutsupoland.com/wp-content/uploads/2020/09/ANKIETA-OSOBOWA-2020.pdf">Ankieta osobowa</a></li>
              </ul>
            </CardContent>
          </Card>
          <Events />
        </Stack>
      </Stack>
      <SnackbarAlert open={openSnackbar} severity="error" message="Wystąpił błąd" onClose={handleCloseSnackbar} />
    </Page>
  );
};


export default ClientData;
